// extracted by mini-css-extract-plugin
export default {"label":"TelegramTextarea_label__mJQxR","textarea":"TelegramTextarea_textarea__GkmF4","button":"TelegramTextarea_button__pqt5c"};